import { render, staticRenderFns } from "./setting-productCodeRedemption.vue?vue&type=template&id=15b63886&scoped=true&"
import script from "./setting-productCodeRedemption.vue?vue&type=script&lang=js&"
export * from "./setting-productCodeRedemption.vue?vue&type=script&lang=js&"
import style0 from "./setting-productCodeRedemption.vue?vue&type=style&index=0&id=15b63886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b63886",
  null
  
)

export default component.exports